<template>
    <div>
      <label v-if="label">{{ label }}</label>
      <textarea ref="editor" :placeholder="placeholder" class="form-control" />
  
      <div v-if="error" class="v-messages error--text">
        {{ error }}
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'TrumbowygEditor',
    props: {
      value: String,                // Para v-model
      label: String,                // Etiqueta opcional
      placeholder: String,          // Placeholder opcional
      error: String,                // Mensaje de error (opcional)
      config: Object                // Configuración personalizada
    },
    mounted() {
  this.$nextTick(() => {
    const $editor = $(this.$refs.editor)

    if (typeof $editor.trumbowyg !== 'function') {
      console.error('Trumbowyg no está definido')
      return
    }

    const configFinal = Object.assign(
      {
        lang: 'es',
        btns: [
          ['viewHTML'],
          ['formatting'],
          ['strong', 'em', 'del'],
          ['link'],
          ['insertImage'],
          ['unorderedList', 'orderedList'],
          ['fullscreen']
        ]
      },
      this.config || {}
    )

    $editor.trumbowyg(configFinal)
    $editor.trumbowyg('html', this.value || '')
    $editor.on('tbwchange', () => {
      this.$emit('input', $editor.trumbowyg('html'))
    })
  })
},
    watch: {
      value(newVal) {
        // Si cambia desde fuera, actualiza el editor
        const currentVal = $(this.$refs.editor).trumbowyg('html')
        if (newVal !== currentVal) {
          $(this.$refs.editor).trumbowyg('html', newVal)
        }
      }
    }
  }
  </script>
  